import { render, staticRenderFns } from "./VerticalTabs.vue?vue&type=template&id=7a10a914&scoped=true&"
import script from "./VerticalTabs.vue?vue&type=script&lang=ts&"
export * from "./VerticalTabs.vue?vue&type=script&lang=ts&"
import style0 from "./VerticalTabs.vue?vue&type=style&index=0&id=7a10a914&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a10a914",
  null
  
)

export default component.exports